<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <div class="card dropdown-content subsidy-wise-report-header" style="margin-bottom: 5px;">
        <div class="p-fluid p-formgrid grid">
            <div class="field col-12 md:col-4">
                <label htmlFor="selectDistrict">{{'SELECT_DISTRICT'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="districtData" [(ngModel)]="selectedDistrict" (onChange)="onSelectDistrict()"
                        placeholder="{{'SELECT_DISTRICT'| translate}}" optionLabel="District"></p-dropdown>
                </div>
            </div>

            <div class="field col-12 md:col-4">
                <label htmlFor="selectBlock">{{'SELECT_BLOCK'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="blockData" [(ngModel)]="selectedBlock" (onChange)="onSelectBlock()"
                        placeholder="{{'SELECT_BLOCK'| translate}}" optionLabel="Block"></p-dropdown>
                </div>
            </div>

            <!-- <div class="field col-12 md:col-4">
                <label htmlFor="selectVillage">{{'SELECT_VILLAGE'| translate}}</label>
                <div class="grid-item">
                    <p-dropdown [options]="villageData" [(ngModel)]="selectedVillage" (onChange)="onSelectVillage()"
                        placeholder="{{'SELECT_VILLAGE'| translate}}" optionLabel="name"></p-dropdown>
                </div>
            </div> -->
        </div>
    </div>

    <div class="card dashboardTable mt-4" *ngIf="showTable">
        <p-toolbar styleClass="mb-4" *ngIf="tableDataToShow.length > 0">
            <ng-template pTemplate="left">
            </ng-template>
            <ng-template pTemplate="right">
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}"
                    icon="pi pi-upload" class="p-button-help"></button>
                <p-menu #menu [popup]="true" [model]="exportType"></p-menu>
            </ng-template>
        </p-toolbar>
        <p-table #subsidyWiseDetails [value]="tableDataToShow" dataKey="AppID" [rows]="10" [paginator]="true" [globalFilterFields]="[
        'AppID',
		'FarmerShare_to_Vendor',
		'Subsidy_to_Vendor',
		'Subsidy_Amt_Farmer',
		'Subsidy_Amt_Stage1',
		'Subsidy_Amt_Stage2',
		'Subsidy_Amt_Stage3',
		'District',
		'Block',
		'Village',
		'Scheme',
		'Water_Source_Name',
        'FinYear',
        'ProgramName',
        'VendorName'
        ]" responsiveLayout="scroll" [rowHover]="true"
            currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
            [showCurrentPageReport]="true" [loading]="loading">
            <ng-template pTemplate="caption">
                <div class="flex align-items-center justify-content-between">
                    <h5 class="m-0">{{'SUBSIDY_WISE_DETAILS'| translate}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="subsidyWiseDetails.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="AppID">{{'APP_ID'| translate}}
                        <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                        <p-sortIcon field="AppID"></p-sortIcon>
                    </th>
                    <th pSortableColumn="District">{{'DISTRICT'| translate}}
                        <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                        <p-sortIcon field="District"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Block">{{'BLOCK'| translate}}
                        <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                        <p-sortIcon field="Block"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                        <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                        <p-sortIcon field="Village"></p-sortIcon>
                    </th>
                    <th pSortableColumn="ProgramName">{{'PROGRAM_NAME'| translate}}
                        <p-columnFilter type="text" field="ProgramName" display="menu"></p-columnFilter>
                        <p-sortIcon field="ProgramName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                        <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                        <p-sortIcon field="VendorName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Scheme">{{'SCHEME'| translate}}
                        <p-columnFilter type="text" field="Scheme" display="menu"></p-columnFilter>
                        <p-sortIcon field="Scheme"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Water_Source_Name">{{'TYPE_OF_WATER_SOURCE'| translate}}
                        <p-columnFilter type="text" field="Water_Source_Name" display="menu"></p-columnFilter>
                        <p-sortIcon field="Water_Source_Name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                        <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                        <p-sortIcon field="FinYear"></p-sortIcon>
                    </th>
                    <th pSortableColumn="FarmerShare_to_Vendor">{{'FARMER_SHARE_TO_VENDOR'| translate}}
                        <p-columnFilter type="text" field="FarmerShare_to_Vendor" display="menu"></p-columnFilter>
                        <p-sortIcon field="FarmerShare_to_Vendor"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_to_Vendor">{{'SUBSIDY_TO_VENDOR'| translate}}
                        <p-columnFilter type="text" field="Subsidy_to_Vendor" display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_to_Vendor"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Amt_Farmer">{{'SUBSIDY_TO_FARMER'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Amt_Farmer" display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Amt_Farmer"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Amt_Stage1">{{'SUBSIDY_AMOUNT_STAGE1'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Amt_Stage1" display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Amt_Stage1"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Amt_Stage2">{{'SUBSIDY_AMOUNT_STAGE2'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Amt_Stage2" display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Amt_Stage2"></p-sortIcon>
                    </th>
                    <th pSortableColumn="Subsidy_Amt_Stage3">{{'SUBSIDY_AMOUNT_STAGE3'| translate}}
                        <p-columnFilter type="text" field="Subsidy_Amt_Stage3" display="menu"></p-columnFilter>
                        <p-sortIcon field="Subsidy_Amt_Stage3"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-res>
                <tr>
                    <td><a (click)="selectFarmerApplication(res)" style="cursor: pointer;">{{ res?.AppID }}</a></td>
                    <td>{{ res?.District }}</td>
                    <td>{{ res?.Block }}</td>
                    <td>{{ res?.Village }}</td>
                    <td>{{ res?.ProgramName }}</td>
                    <td>{{ res?.VendorName }}</td>
                    <td>{{ res?.Scheme }}</td>
                    <td>{{ res?.Water_Source_Name }}</td>
                    <td>{{ res?.FinYear }}</td>
                    <td>{{ res?.FarmerShare_to_Vendor }}</td>
                    <td>{{ res?.Subsidy_to_Vendor }}</td>
                    <td>{{ res?.Subsidy_Amt_Farmer }}</td>
                    <td>{{ res?.Subsidy_Amt_Stage1 }}</td>
                    <td>{{ res?.Subsidy_Amt_Stage2 }}</td>
                    <td>{{ res?.Subsidy_Amt_Stage3 }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between">
                    {{'IN_TOTAL_THERE_ARE'| translate}} {{tableDataToShow ? tableDataToShow.length : 0 }}
                    {{'SUBSIDY_WISE_DETAILS'| translate}}
                </div>
            </ng-template>

        </p-table>
    </div>
</p-card>